import {adminGuard} from '../guards';
import AdminFaxSnippets from '../../pages/fax/admin/snippets/FaxSnippets';
import AdminCreateFaxSnippet from '../../pages/fax/admin/snippets/CreateFaxSnippet';
import AdminEditFaxSnippet from '../../pages/fax/admin/snippets/EditFaxSnippet';
import AdminFaxMessages from '../../pages/fax/admin/AdminFaxMessages';
import AdminFaxContacts from '../../pages/fax/admin/AdminFaxContacts';
import AdminCreateFaxContact from '../../pages/fax/admin/AdminCreateFaxContact';
import AdminEditFaxContact from '../../pages/fax/admin/AdminEditFaxContact';
import AdminShowFaxMessage from '../../pages/fax/admin/AdminShowFaxMessage';

const adminRoutes = [
  {
    path: '/v2/admin/fax',
    name: 'admin.fax.index',
    redirect: '/v2/admin/fax/messages',
    meta: {
      permission: 'can_edit_faxes',
    },
  },
  {
    path: '/v2/admin/fax/contacts',
    name: 'admin.fax_contacts.index',
    component: AdminFaxContacts,
    meta: {
      permission: 'can_edit_faxes',
      title: 'Fax Contacts',
    }
  },
  {
    path: '/v2/admin/fax/contacts/create',
    name: 'admin.fax_contact.create',
    component: AdminCreateFaxContact,
    meta: {
      permission: 'can_edit_faxes',
      title: 'New Fax Contact',
    }
  },
  {
    path: '/v2/admin/fax/contacts/:contactID(\\d+)/edit',
    name: 'admin.fax_contact.edit',
    component: AdminEditFaxContact,
    meta: {
      permission: 'can_edit_faxes',
      title: 'Edit Fax Contact',
    }
  },
  {
    path: '/v2/admin/fax/messages',
    name: 'admin.fax_messages.index',
    component: AdminFaxMessages,
    meta: {
      permission: 'can_edit_faxes',
      title: 'Fax Messages',
    }
  },
  {
    path: '/v2/admin/fax/messages/:messageID(\\d+)',
    name: 'admin.fax_message.show',
    component: AdminShowFaxMessage,
    meta: {
      permission: 'can_edit_faxes',
      title: 'Fax Message',
    }
  },
  {
    path: '/v2/admin/fax/snippets',
    name: 'admin.fax_snippets.index',
    component: AdminFaxSnippets,
    meta: {
      permission: 'can_edit_faxes',
      title: 'Fax Snippets',
    }
  },
  {
    path: '/v2/admin/fax/snippets/create',
    name: 'admin.fax_snippet.create',
    component: AdminCreateFaxSnippet,
    meta: {
      permission: 'can_edit_faxes',
      title: 'New Fax Snippet',
    }
  },
  {
    path: '/v2/admin/fax/snippets/:snippetID(\\d+)',
    name: 'admin.fax_snippet.edit',
    component: AdminEditFaxSnippet,
    meta: {
      permission: 'can_edit_faxes',
      title: 'Edit Fax Snippet',
    }
  },
];

export default [
  ...adminGuard(adminRoutes),
];
